/**
 * Arrow navigation for CSS scroll-snap shelf.
 */
if (!customElements.get('gltheaa-new-arrivals')) {
  class GltheaaNewArrivals extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-new-arrivals-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-new-arrivals-prev]');
      this.nextButton = this.querySelector('[data-new-arrivals-next]');

      this.onPrev = () => this.scrollByDir(-1);
      this.onNext = () => this.scrollByDir(1);

      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
    }

    scrollByDir(direction) {
      const item = this.track.querySelector('.gltheaa-new-arrivals__item');
      if (!item) return;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const amount = item.getBoundingClientRect().width + gap;

      this.track.scrollBy({
        left: direction * amount,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('gltheaa-new-arrivals', GltheaaNewArrivals);
}
